export default __webpack_public_path__ + "static/media/5.214cd6ce.jpg";